"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.load.error': 'Failed to load slot data',
};
